import { action } from 'typesafe-actions';

import { ControlBarView, DocumentViewerType, PdfActionTypes, PDFPageHighlights, PdfPageText, PdfSearchResults, PdfSearchSettings, PDFSearchType } from './types';

export const setPdfText = (pdfText: PdfPageText) => action(PdfActionTypes.SET_PDF_TEXT, pdfText);

export const setScheduleStartPage = (startPage: number) => action(PdfActionTypes.SET_SCHEDULE_START_PAGE, startPage);

export const setPdfSearchTerm = (value: string) => action(PdfActionTypes.SET_PDF_SEARCH_TERM, value);

export const setCurrentPdfPage = (value: number) => action(PdfActionTypes.SET_CURRENT_PDF_PAGE, value);

export const setSearchResults = (results: PdfSearchResults[]) => action(PdfActionTypes.SET_PDF_SEARCH_RESULTS, results);

export const setScrollToInitialSearchResults = (value: boolean) => action(PdfActionTypes.SET_SCROLL_TO_INITIAL_RESULT, value);

export const setSelectedSearchResult = (selected: PdfSearchResults) => action(PdfActionTypes.SET_SELECTED_SEARCH_RESULT, selected);

export const clearPdfSearchTerm = () => action(PdfActionTypes.CLEAR_PDF_SEARCH_TERM);

export const resetPdfSearch = () => action(PdfActionTypes.RESET_PDF_SEARCH);

export const resetPdfText = () => action(PdfActionTypes.RESET_PDF_TEXT);

export const cancelSearchSettings = () => action(PdfActionTypes.CANCEL_SEARCH_SETTINGS);

export const applySearchSettings = () => action(PdfActionTypes.APPLY_SEARCH_SETTINGS);

export const updateSearchSettings = (key: keyof PdfSearchSettings, value: PDFSearchType | boolean) => action(PdfActionTypes.UPDATE_SEARCH_SETTINGS, { key, value });

export const setControlBarView = (view: ControlBarView) => action(PdfActionTypes.SET_CONTROL_BAR_VIEW, view);

export const setNumberOfPages = (numberOfPages: number | null) => action(PdfActionTypes.SET_PDF_NUMBER_OF_PAGES, numberOfPages);

export const setIndexesToHighlight = (value: PDFPageHighlights) => action(PdfActionTypes.SET_INDEXES_TO_HIGHLIGHT, value);

export const setIsCheckingHighlightIndexes = (isChecking: boolean) => action(PdfActionTypes.SET_IS_CHECKING_HIGHLIGHT_INDEXES, isChecking);

export const setDocumentViewerType = (type: DocumentViewerType | null) => action(PdfActionTypes.SET_DOCUMENT_VIEWER_TYPE, type);
